import _ from 'lodash';

export class AbstractModel<T> {
  constructor(public data: T) {}

  get id() {
    return this.get('_id');
  }

  get json() {
    return {
      ...this.data,
    };
  }

  /** @deprecated */
  public get(key: string) {
    return _.get(this.data, key);
  }

  /** @deprecated */
  public set(key: string, val: any) {
    this.data[key] = val;
  }

  public extend(data: Partial<T>) {
    this.data = {
      ...this.data,
      ...data,
    };
  }
}
